import { EducationEntry } from 'utils/cv-form-db';

export const USE_UNIVERSITIES_QUERY_KEY = 'universities';
export const UNIVERSITIES_API_URL = 'data/universities';

export const USE_STUDIES_QUERY_KEY = 'studyPrograms';
export const STUDIES_API_URL = 'data/studyPrograms';

export const USE_DEGREES_QUERY_KEY = 'degrees';
export const DEGREES_API_URL = 'data/degrees';

export const initialValues: EducationEntry = {
  university: '',
  study: '',
  degree: '',
  currentlyEnrolled: false,
  studyStart: '',
  studyEnd: ''
};
